import { useState, useEffect } from 'react'
import '../../../FormGenericHooks.scss'
import '../../Components/App.css'
import { useParams } from 'react-router-dom'
import { newFormServiceTypeAtom, formTypeAtom } from '../../../State/Atoms/FormProps/FormPropsAtoms'
import { newFormAssetTypeAtom } from '../../../State/Atoms/AssetData/AssetDataAtoms'
import { useRecoilState, useSetRecoilState } from 'recoil'
import NewFormChoices from './Components/NewFormChoices'

export const NewForm = () => {
    const match = useParams()

    const [, setFormId] = useState(-1)
    const [, setRecordId] = useState(-1)
    const [, setRecoveryId] = useState(-1)

    const setFormType = useSetRecoilState(formTypeAtom)

    const [, setNewFormAssetType] = useRecoilState(newFormAssetTypeAtom)

    const [, setNewFormServiceType] = useRecoilState(newFormServiceTypeAtom)

    // Using useEffect to safely update formType and other state values
    useEffect(() => {
        setFormId(match.formId ? match.formId : -1)
        setRecordId(match.recordId ? match.recordId : -1)
        setRecoveryId(match.recoveryId ? match.recoveryId : -1)
    }, [match.formId, match.recordId, match.recoveryId])

    useEffect(() => {
        setFormType(match.formType ? match.formType : '')
        setNewFormAssetType(
            match.params?.customerAssetTypeID ? match.params.customerAssetTypeID : ''
        )
        setNewFormServiceType(match.params?.serviceType ? match.params.serviceType : '')
    }, [match.formType, setFormType])

    return (
        <div className='formGenericTheme'>
            <div className='formGenericContainer'>
                <form className='form-inline'>
                    <NewFormChoices />
                </form>
            </div>
        </div>
    )
}
